<template>
    <div id="wrapper" class=" wrapper-left-fixed wrapper-header-fixed">
        <div class="d-sm-flex justify-content-sm-center d-block">
            <div class="card card-light p-0 my-sm-4 my-0">
                <div class="box-account">
                    <img class="box-account-logo" src="/static/img/logo/talk-logo.jpg"/>
                    <h6 class="box-account-title">Agency Login </h6>
                    <b-form class="box-account-form" @submit="onSubmit" @reset="onReset">
                        <span class="reauth-email"> </span>
                        <b-form-input v-model="form.email" type="text" required placeholder="Email"></b-form-input>
                        <b-form-input v-model="form.password" type="password" required placeholder="Password"></b-form-input>
                        <b-button class="btn btn-danger btn-lg btn-block btn-wave-light" type="submit">Login</b-button>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/services/api.js'
import utils from '@/services/utilities.js'
import service from '@/services/service.js'
export default {
  name: 'Login',
  data () {
    return {
      form:{
        email:'',
        password:''
      }
    }
  },
  methods:{
    onSubmit(e){
      e.preventDefault();
      utils.loading();
      api.api_post('/users/signin','', this.form, (resp)=>{
          console.log('login resp:', resp);
          utils.stopLoading();
          if (JSON.stringify(resp.agency)==={}){
            alert('You a not an agent!');
          }else{
            service.saveobject('me', resp);
            this.$router.push('/main');
          }
      }, (code, err)=>{
        utils.stopLoading();
        alert(err);
      });
    },
    onReset(e){
      e.preventDefault();
      this.form.email = '';
      this.form.password = '';
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue